import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';

import PageWrapper from '../../common/PageWrapper';
import { useMerchant } from '../../contexts/MerchantContext';
import { useCanManagePortalUsers } from '../../hooks';
import { configurationPaths } from '../../util/constants';
import { MerchantUsersTable } from './components/MerchantUsersTable';

export const MerchantUsers = () => {
  const { isLoading: merchantInfoLoading } = useMerchant();
  const canManagePortalUsers = useCanManagePortalUsers();

  if (!canManagePortalUsers) {
    return <Navigate to={configurationPaths.SETTINGS} replace />;
  }

  return (
    <PageWrapper
      data-testid="MERCHANT_USERS"
      title="Users"
      description="Add and manage portal users with direct access to this merchant."
      isLoading={merchantInfoLoading}
    >
      <Box>
        <MerchantUsersTable />
      </Box>
    </PageWrapper>
  );
};
